var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"height100 d-flex justify-center align-center"},[_c('div',[_c('p',[_vm._v("Redirecting... Please be patient!")]),_c('v-progress-linear',{attrs:{"color":"primary","indeterminate":"","rounded":"","height":"6"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }